import { render, staticRenderFns } from "./UpLoadVideo.vue?vue&type=template&id=6a7afb14&scoped=true&"
import script from "./UpLoadVideo.vue?vue&type=script&lang=js&"
export * from "./UpLoadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UpLoadVideo.vue?vue&type=style&index=0&id=6a7afb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7afb14",
  null
  
)

export default component.exports